export const InitialValuesCustomerPassword = {
  oldPassword: "",
  newPassword: "",
  newPasswordConfirm: "",
};
